import { render, staticRenderFns } from "./Spend.vue?vue&type=template&id=36b4c66f"
import script from "./Spend.vue?vue&type=script&lang=js"
export * from "./Spend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports